export const iconFontAwesomeGamingDiceD20 = (
	<i className="fa-solid fa-dice-d20"></i>
);
